import * as d3 from "d3";
import {
    addGridlines,
    axisTextDim1,
    colonAnnotation, contextMenu, createTooltip,
    DEFAULT_AXIS_FONT_SIZE,
    DEFAULT_AXIS_LABEL_FONT_SIZE,
    generateDownloadData, inrFormatterV2,
    responsivefy,
    XaxisAttribute
} from '../functions'

export default function (chart, divId, vizName,resData, filterParam,checkbox, gridflag) {
    const defaultSize = true
    const defaultChartLayout = {
        width: 1000,
        height: 400,
        margin: { top: 30, right: 110, bottom: 100, left: 100 }
    }
    const chartWidth = defaultSize ? defaultChartLayout.width : chart.width
    const chartHeight = defaultSize ? defaultChartLayout.height : chart.height
    const chartMargin = defaultSize ? defaultChartLayout.margin : chart.margin

    var size = defaultSize ? DEFAULT_AXIS_FONT_SIZE : chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = (defaultSize ? DEFAULT_AXIS_LABEL_FONT_SIZE : chart.axisLabelFontSize) + "px"

    // set the ranges
    var x1Scale = d3.scaleBand().rangeRound([0, chartWidth]).padding(0.1);
    var y1Scale = d3.scaleLinear().rangeRound([chartHeight, 0]);
    var y2Scale = d3.scaleLinear().rangeRound([chartHeight, 0]);
    // define the axis
    var x1AxisLabel = d3.axisBottom().scale(x1Scale);
    var y1AxisLabel = d3.axisLeft().scale(y1Scale).tickFormat(function (d){return inrFormatterV2(d,chart.data.menuId)});
    var y2AxisLabel = d3.axisRight().scale(y2Scale).tickFormat(function (d){return inrFormatterV2(d,chart.data.menuId)});


    var valueline = d3.line()
        .x(function (d) {
            return x1Scale(d.dim1_name);
        })
        .y(function (d) {
            return y2Scale(d.metric2);
        });


    const tooltip = createTooltip(divId);

    // add the SVG element
    var svg = d3.select(divId).select("svg").remove();
    svg = d3.select(divId)
        .append("svg")
        .attr("width", chartWidth + chartMargin.left + chartMargin.right)
        .attr("height", chartHeight +  chartMargin.top + chartMargin.bottom)
        .call(responsivefy)
        .append("g")
        .attr("transform", "translate(" + chartMargin.left + "," + chartMargin.top + ")");

    //Calling tooltip
    // svg.call(tip1);

    // load the data
    // axios.post(url, filterParam).then(res => {
        let data = resData

        data.forEach(function (d) {
            d.metric1 = +d.metric1;
        });

        // scale range of the data
        x1Scale.domain(data.map((d) => {
            return d.dim1_name
        }));
        y1Scale.domain([0, d3.max(data, (d) => {
            return d.metric1
        })]);
        y2Scale.domain([0, d3.max(data, (d) => {
            return d.metric2
        })])

        console.log("min", d3.min(data, (d) => {
            return d.dim1_name.substring(0, 4)
        }))
        console.log("max", d3.max(data, (d) => {
            return d.dim1_name.substring(0, 4)
        }))

        var metric1ColorScale = d3.scaleLinear()
            .domain([d3.min(data, (d) => {
                return d.dim1_name.substring(0, 4)
            }),
                d3.max(data, (d) => {
                    return d.dim1_name.substring(0, 4)
                })])
            .range(["#c6dbef", "#2171b5"])

        // color function to decide how to color the bars
        function colorFn(d) {
            let c;
            if (chart.vizSpecific4 == 'yearBasedColor') {
                c = metric1ColorScale(d.dim1_name.substring(0, 4))
            } else {
                c = 'steelblue'
            }
            console.log("Color for bar", c)
            return c;

        }
        if (gridflag === true) {
            addGridlines(svg, x1Scale, y1Scale, chart);
        }

        // add axis
        svg.append("g")
            .attr("class", "x axis")
            .attr("transform", "translate(0," + chartHeight + ")")
            .call(x1AxisLabel)
            .selectAll("text")
            //.attr("class","axisL20")
            .style('font-size', fontSize)
            .style("text-anchor", "start")
            .attr("dx", XaxisAttribute)
            .attr("dy", "-.55em")
            .attr("transform", "rotate(-50)")
            .text(axisTextDim1);

        svg.append('text')
            .attr('x', (chartWidth / 2))
            .attr('y', chartHeight + chartMargin.bottom -10 )
            //.style('fill', 'blue')
            .style("text-anchor", "middle")
            .style('fill', fontColor)
            .style('font-size', axisLabelFontSize)
            .text(chart.x1AxisDisplayName)

        svg.append("g")
            .attr("class", "y axis")
            .call(y1AxisLabel)
            .style("font-size", fontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chartMargin.left + 15)
            .attr('x', 0 - (chartHeight / 2))
            .attr("dy", ".71em")
            .style("text-anchor", "center")
            .style('fill', fontColor)
            .style('font-size', axisLabelFontSize)
            .text(chart.y1AxisDisplayName)

        svg.append("g")
            .attr("class", "y axis")
            .attr("transform", "translate(" + chartWidth + " ,0)")
            .call(y2AxisLabel)
            .style("font-size", fontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', chartWidth + chartMargin.right - 35)
            .attr('x', 0 - (chartHeight / 2))
            .attr('dy', '1em')
            .style('text-anchor', 'center')
            .style('fill', fontColor)
            .style('font-size', axisLabelFontSize)
            .text(chart.y2AxisDisplayName)

        // Add bar chart
        svg.selectAll("bar")
            .data(data)
            .enter()
            .append("rect")
            .attr("class", "bar")
            .attr("x", (d) => {
                return x1Scale(d.dim1_name)
            })
            .attr("width", x1Scale.bandwidth())
            .attr("y", function (d) {
                return y1Scale(d.metric1)
            })
            .style("fill", (d) => {
                return d.dim3_name == null ? colorFn(d) : d.dim3_name
            })
            // .style("fill", (d)=> { return metric1ColorScale(d.dim1_name.substring(0,4) )})
            .attr("height", (d) => {
                return chartHeight - y1Scale(d.metric1)
            })
            .on("mouseover", function(d) {
                tooltip.onMouseOver(d, this, function(d) {
                    // Tooltip content callback
                    return chart.x1MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                        chart.y1MetricTooltip + colonAnnotation + inrFormatterV2(d.metric1,chart.data.menuId)
                });  // Pass the event for positioning
            })
            .on('mousemove', function(event) {
                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
            })
            .on("mouseout", function() {
                // Hide the tooltip on mouse out
                tooltip.onMouseLeave();
            })
            .on('contextmenu', function(d) {

                // Prepare clickedData with both axes' info
                const clickedData = {
                    [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]: [d.dim1_name]               // e.g., "metric1"
                };
                console.log("clickedData",clickedData);
                // Generate the menu with current config and filters
                const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                // Show the context menu
                contextMenu(menuItems).call(this, clickedData);

                // Prevent default context menu
                d3.event.preventDefault();
            });
        // saveSvgAsPng(document.getElementById(divId), "diagram.png");

        //value top of the bar
        svg.selectAll('text.bar')
            .data(data)
            .enter().append('text')
            .attr('class', 'bar')
            .attr('text-anchor', 'middle')
            .attr('x', function (d) {
                return (x1Scale(d.dim1_name) + x1Scale.bandwidth()/2)
            })
            .attr('y', function (d) {
                return y1Scale(d.metric1) - 4
            })
            .text((d) => {
                return inrFormatterV2(d.metric1,chart.data.menuId)
            })
            .attr('fill', 'black')
            //   .attr("dy","3em")
            //.attr("transform", "rotate(-65)")
            //  .attr("transform", function(d) {
            //      return "translate(" + (- (x1Scale(d.dim1_name) + x1Scale.bandwidth() + 140) ) + "," +
            //          ((y1Scale(d.metric1) -110 )) + ") rotate(65)"
            //  })
            .attr("transform", function (d) {
                return "rotate(-65 " + (x1Scale(d.dim1_name) + x1Scale.bandwidth()) + 20 + "," + (y1Scale(d.metric1) - d.dim1_name.length) - 25 + ")"
            })
            //  .attr("transform",function(d){
            //      return "translate(" + x1Scale(d.dim1_name) + "," + y1Scale(d.metric1)  + "rotate(-65)"})
            .style('font-size', fontSize)

        svg.append("path")        // Add the valueline2 path.
            .attr("class", "line")
            .style('fill', 'none')
            .style('stroke', 'blue')
            .style("stroke-width", '3px')
            .attr("d", valueline(data))
            .attr("transform", "translate(" + (x1Scale.bandwidth() / 2) + ",0)");

        svg.selectAll("dot")
            .data(data)
            .enter()
            .append("circle")
            .attr("r", 6)
            .attr("cx", function (d) {
                return x1Scale(d.dim1_name)+x1Scale.bandwidth()/2;
            })
            .attr("cy", function (d) {
                return y2Scale(d.metric2);
            })
            .style("font-size", fontSize)
            .style("fill", 'blue')
            .on("mouseover", function(d) {
                tooltip.onMouseOver(d, this, function(d) {
                    // Tooltip content callback
                    return chart.x1MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                        chart.y2MetricTooltip + colonAnnotation + inrFormatterV2(d.metric2,chart.data.menuId)
                });  // Pass the event for positioning
            })
            .on('mousemove', function(event) {
                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
            })
            .on("mouseout", function() {
                // Hide the tooltip on mouse out
                tooltip.onMouseLeave();
            })
            .on('contextmenu', function(d) {

                // Prepare clickedData with both axes' info
                const clickedData = {
                    [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]: [d.dim1_name]               // e.g., "metric1"
                };
                console.log("clickedData",clickedData);
                // Generate the menu with current config and filters
                const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                // Show the context menu
                contextMenu(menuItems).call(this, clickedData);

                // Prevent default context menu
                d3.event.preventDefault();
            });

// Append text on circles
        svg.selectAll(".circle")  // Use the same class for both circles and text
            .data(data)
            .enter()
            .append("text")
            .attr("x", function (d) {
                return x1Scale(d.dim1_name) + x1Scale.bandwidth() / 1.9;
            })
            .attr("y", function (d) {
                return y2Scale(d.metric2)+7; // Adjust the y-coordinate as needed
            })
            .attr("text-anchor", "start")
            .style("font-size", fontSize)
            .text(function (d) {
                console.log("metricdata", d.metric2);
                return inrFormatterV2(d.metric2,chart.data.menuId);
            })
            .style('fill','blue');

}
